import axios from "./axios";

export const orderDetail = (data) => axios.post(`/api/v1/orderDetail`, data);

export const orderSubmit = (data) => axios.post(`/api/v1/orderSubmit`, data);

export const getH5ProductList = (data) =>
  axios.post(`/api/v1/H5productList`, data);

export const h5ProductView = (data) => axios.post(`/app/v1/product_view`, data);

// 配置接口
export const config = (data) => axios.post(`/app/v1/config`, data);
// 获取验证码
export const get_sms_code = (data) => axios.post(`/app/v1/get_sms_code`, data);
// 登录
export const login = (data) => axios.post(`/app/v1/login`, data);
// 获取用户信息
export const get_user_info = (data) =>
  axios.post(`/app/v1/get_user_info`, data);
// 贷超列表
export const get_list = (data) => axios.post(`/app/v1/daichao`, data);
// 进件接口（申请接口)
export const save_order = (data) => axios.post(`/app/v1/save_order`, data);
// 获取城市列表
export const citylist = (data) => axios.post(`/app/v1/area`, data);
// 撞库
export const check_order = (data) =>
  axios.post(`/app/v1/check_order`, data, { notCheckCode: true });
export const h5_get_product_info = (data) =>
  axios.post(`/app/v1/h5_get_product_info`, data);
// 半流程获取产品信息
export const apply_half_order_detail = (data) =>
  axios.post(`/app/v1/apply_half_order_detail`, data);
// 半流程提交
export const apply_half_order_submit = (data) =>
  axios.post(`/app/v1/apply_half_order_submit`, data);
export const channel_view = (data) => axios.post(`/app/v1/channel_view`, data);
export const ip2city = (data) => axios.post(`/app/v1/ip2city`, data);
